import { HroasConstraintData as ConstraintData } from '@blisspointmedia/bpm-types/dist/OptimizationConstraints';
import { createContext } from 'react';

export const ROUTES = {
  CONSTRAINTS: {
    key: 'constraints',
    label: 'Constraints',
    uri: 'constraints',
    depth: 1
  },
  OPTIMIZATIONS: {
    key: 'optimizations',
    label: 'Optimizations',
    uri: 'optimizations'
  },
  RUNS: {
    key: 'runs',
    label: 'Runs',
    uri: 'runs',
    depth: 1
  }
};

export interface ConstraintListItem {
  name: string;
  lastmodified: string;
  lastuser?: string;
}

export interface Optimization {
  build_number: string;
  status: string;
  date: string;
  start: string;
  end: string;
  constraint_name: string;
  objective_value?: number;
  cost?: string;
  budget?: string;
  company_id: string;
  branch: string;
  progress?: number;
}

export interface RunResultItem {
  feature?: string;
  channel?: string;
  kind?: string;
  feature_spend: number;
  [key: string]: unknown;
}

export interface CopyConstraintParams {
  from: string;
  to: string;
}

export interface DeleteConstraintParams {
  deleteConstraintId: string;
}

export interface NewConstraintParams {
  name: string;
}

export interface RunOptimizationParams {
  name: string;
}

export interface ConstraintCandidates {
  dgFeatures: string[];
  dcFeatures: string[];
}

export interface OptimizationsContextValue {
  company: string;
  optimizations?: Optimization[];
  constraintsList?: ConstraintListItem[];
  constraintData?: ConstraintData;
  savingConstraint: boolean;
  constraintCandidates?: ConstraintCandidates;
  setConstraintData: (data: ConstraintData) => void;
  copyConstraint: (params: CopyConstraintParams) => Promise<void>;
  deleteConstraint: (params: DeleteConstraintParams) => Promise<void>;
  runOptimization: (params: RunOptimizationParams) => Promise<void>;
  runResult?: RunResultItem[];
  runId?: string;
}

export const OptimizationsContext = createContext<OptimizationsContextValue>(
  {} as OptimizationsContextValue
);
